export default [
  {
    name: 'Comunicaciones automaticas',
    icon: 'mdi-email-outline',
    path: '/admin/user-actions',
    component: () =>
      import(/* webpackChunkName: "admin-user-actions" */ './views/UserActionsPage.vue'),
    meta: {
      admin: true,
      allowedRoles: ['admin', 'superadmin', 'consultant'],
      adminToolbar: false,
      adminDrawer: true,
      tooltip: 'Trazabilidad de comunicaciones automaticas',
    },
  },
];
